<template>
  <div style="line-height: 1.333333;">
    <div class="black--text"><strong>Bill To</strong></div>
    <div style="padding-top: 2px;">
      <div>{{ pro.business_name }}</div>
      <div>{{ pro.address.street }}</div>
      <div>{{ pro.address.city }}, {{ pro.address.state }}, {{ pro.address.zipcode }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BillTo',

  props: {
    pro: {
      type: Object,
      required: true,
    },
  },
}
</script>